import CustomHTMLElement from './../../../elements/customHTMLElement';

export default class Pager extends CustomHTMLElement {
    /**
     * @param {Object} [properties]
     * @param {Number} [properties.currentPage]
     * @param {Number} [properties.totalPages]
     * @param {String} [properties.prevTitle]
     * @param {String} [properties.nextTitle]
     */
    constructor(properties = {}) {
        super({
            currentPage: 1,
            totalPages: 1,
            prevTitle: 'Ga naar de vorige pagina',
            nextTitle: 'Ga naar de volgende pagina',
            nextLabel: 'Volgende',
            ofLabel: 'van'
        });
        this._createPropertyMethods();
        this.setProperties(properties);
        this._template = require('./templates/pager.handlebars');
    }

    setCurrentPage(currentPage = this.currentPage) {
        this._property('currentPage', this._ensureType(currentPage, typeof this._property('currentPage')));

        if (this._object) {
            this.getOrCreate().querySelectorAll('.currentPage').forEach(currentPage => currentPage.innerHTML = this.currentPage);
            this.setButtonStatus();
        }
        return this.currentPage;
    }

    setTotalPages(totalPages = this.totalPages) {
        this._property('totalPages', this._ensureType(totalPages, typeof this._property('totalPages')));

        if (this._object) {
            this.getOrCreate().querySelectorAll('.totalPages').forEach(totalPages => totalPages.innerHTML = this.totalPages);
            this.setButtonStatus();
        }
        return this.totalPages;
    }

    getOrCreate(forceCreate = false) {
        let regenerateEvents = false;
        if (!this._object || forceCreate) {
            regenerateEvents = true;
        }

        super.getOrCreate(forceCreate);
        
        if (regenerateEvents) {
            this.setButtonStatus();
            this.setEventDispatchers();
        }
        return this._object;
    }

    setButtonStatus() {
        if (this._object) {
            if (this.currentPage >= this.totalPages) {
                this.getOrCreate().querySelectorAll('.next').forEach(next => next.setAttribute('disabled', 'disabled'));
            } else {
                this.getOrCreate().querySelectorAll('.next').forEach(next => next.removeAttribute('disabled'));
            }

            if (this.currentPage <= 1) {
                this.getOrCreate().querySelectorAll('.prev').forEach(prev => prev.setAttribute('disabled', 'disabled'));
            } else {
                this.getOrCreate().querySelectorAll('.prev').forEach(prev => prev.removeAttribute('disabled'));
            }
        }
    }

    setEventDispatchers() {
        if (this._object) {
            this.getOrCreate().querySelectorAll('.prev').forEach(prev => {
                prev.addEventListener('click', e => {
                    e.preventDefault();
                    const event = new CustomEvent('prev');
                    this._object.dispatchEvent(event);
                });
            });

            this.getOrCreate().querySelectorAll('.next').forEach(next => {
                next.addEventListener('click', e => {
                    e.preventDefault();
                    const event = new CustomEvent('next');
                    this._object.dispatchEvent(event);
                });
            });
        }
    }
}